import React from 'react'
import { Section, SectionTitle, SubSection, SubSectionTitle, Text, List } from '../styles'

export default function ScalabilitySection() {
  return (
    <Section id="scalability">
      <SectionTitle>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M16 8v8h-2V8h2m-4 4v4h-2v-4h2m-4 8H4V4h12v4h2V4a2 2 0 0 0-2-2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h4v-2m10-6h-2v2h2v-2m0-4h-2v2h2v-2m0-4h-2v2h2v-2z"/>
        </svg>
        6. Scalability & Performance
      </SectionTitle>
      
      <SubSection id="infrastructure">
        <SubSectionTitle>6.1 Infrastructure Design</SubSectionTitle>
        <Text>
          Our infrastructure is designed for maximum scalability and
          reliability:
        </Text>
        <List>
          <li>
            Distributed Architecture:
            <ul>
              <li>Microservices-based design</li>
              <li>Container orchestration with Kubernetes</li>
              <li>Global load balancing</li>
              <li>Multi-region deployment</li>
            </ul>
          </li>
          <li>
            High Availability:
            <ul>
              <li>Automatic failover</li>
              <li>Data replication</li>
              <li>Zero-downtime deployments</li>
              <li>Disaster recovery</li>
            </ul>
          </li>
        </List>
      </SubSection>

      <SubSection id="optimization-strategies">
        <SubSectionTitle>6.2 Optimization Strategies</SubSectionTitle>
        <Text>
          Multiple optimization strategies ensure optimal performance:
        </Text>
        <List>
          <li>
            Caching:
            <ul>
              <li>Multi-layer caching strategy</li>
              <li>Distributed cache</li>
              <li>Cache invalidation protocols</li>
              <li>Predictive caching</li>
            </ul>
          </li>
          <li>
            Database Optimization:
            <ul>
              <li>Query optimization</li>
              <li>Index management</li>
              <li>Connection pooling</li>
              <li>Sharding strategies</li>
            </ul>
          </li>
        </List>
      </SubSection>

      <SubSection id="monitoring">
        <SubSectionTitle>6.3 Performance Monitoring</SubSectionTitle>
        <Text>
          Comprehensive monitoring ensures optimal system performance:
        </Text>
        <List>
          <li>
            Metrics Collection:
            <ul>
              <li>Real-time performance metrics</li>
              <li>Resource utilization tracking</li>
              <li>Error rate monitoring</li>
              <li>User experience metrics</li>
            </ul>
          </li>
          <li>
            Alerting:
            <ul>
              <li>Automated alert generation</li>
              <li>Incident escalation</li>
              <li>Performance degradation detection</li>
              <li>SLA monitoring</li>
            </ul>
          </li>
        </List>
      </SubSection>
    </Section>
  )
}
